import { useState } from "react";
import { ShieldCheck, AlertTriangle, ShieldAlert } from "lucide-react";

export default function ComplianceBadge({ check }) {
  const [open, setOpen] = useState(false);
  if (!check) {
    return <span className="stamp stamp-warn">Validating...</span>;
  }
  const map = {
    compliant: { cls: "stamp-ok", label: "API Certified", Icon: ShieldCheck },
    warning: { cls: "stamp-warn", label: "Review Required", Icon: AlertTriangle },
    non_compliant: { cls: "stamp-bad", label: "Non-Compliant", Icon: ShieldAlert },
  };
  const cfg = map[check.overall] || { cls: "stamp-warn", label: check.overall || "Unknown", Icon: AlertTriangle };
  return (
    <div className="relative inline-block">
      <button
        onClick={() => setOpen(!open)}
        className={`stamp ${cfg.cls}`}
        data-testid="compliance-badge"
      >
        <cfg.Icon className="w-3 h-3" />
        {cfg.label}
      </button>
      {open && check.flags && (
        <div className="absolute z-20 right-0 mt-2 w-80 glass p-4 text-left">
          <div className="font-mono-data text-[10px] tracking-widest uppercase text-text-secondary mb-2">Compliance Detail</div>
          <div className="text-sm mb-3 text-text-primary">{check.summary}</div>
          <div className="space-y-2">
            {check.flags.length === 0 && (
              <div className="text-xs text-text-secondary">No flags raised.</div>
            )}
            {check.flags.map((f, i) => (
              <div key={i} className="border-l-2 border-amber-500/50 pl-3 py-1">
                <div className="font-mono-data text-xs">{f.item}</div>
                <div className="text-xs text-text-secondary">{f.issue}</div>
                <div className="font-mono-data text-[9px] uppercase tracking-widest text-amber-500 mt-0.5">
                  Severity · {f.severity}
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
